export interface ProjectLocalConfig {
  madId: number;
  isGit: boolean;
  dynApiEndpoint: string;
  googleLinkEnabled: boolean;
  launchpad?: boolean;
  proxyEndpoint?: string;
  disabledPages?: string[];
}

const defaultConfig: ProjectLocalConfig = {
  madId: null,
  isGit: false,
  dynApiEndpoint:
    'https://dynapi-internal.dev.socialpointgames.com/environments',
  googleLinkEnabled: false,
  launchpad: true,
  disabledPages: [],
};

export function getProjectLocalConfig(project: string): ProjectLocalConfig {
  return projectsLocalConfig[project];
}

function extendDefaultConfig(
  config: Partial<ProjectLocalConfig> = {},
): ProjectLocalConfig {
  return {
    ...defaultConfig,
    ...config,
  };
}

const projectsLocalConfig: Record<string, ProjectLocalConfig> = {
  dc: extendDefaultConfig({
    madId: 74,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-dc.socialpointgames.com/environments',
    googleLinkEnabled: true,
    launchpad: false,
  }),
  mc: extendDefaultConfig({
    madId: 73,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-mc.socialpointgames.com/environments',
    googleLinkEnabled: true,
    launchpad: false,
  }),
  pg: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-pg.socialpointgames.com/environments',
    launchpad: false,
  }),
  gctpg: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://gctpg-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  rck79: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://rck79-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  lpt8: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://gctpg-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  rck7d: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://gctpg-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  spr: extendDefaultConfig({
    madId: 222,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-spr.socialpointgames.com/environments',
    launchpad: false,
  }),
  wl: extendDefaultConfig({
    madId: 150,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-wl.socialpointgames.com/environments',
    launchpad: false,
  }),
  bg: extendDefaultConfig({
    madId: 79,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-bg.socialpointgames.com/environments',
    launchpad: false,
  }),
  twd: extendDefaultConfig({
    madId: 323,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-twd.socialpointgames.com/environments',
    googleLinkEnabled: true,
    launchpad: false,
  }),
  demo: extendDefaultConfig({
    isGit: true,
    disabledPages: [],
  }),
  rt: extendDefaultConfig({
    madId: 358,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-rt.socialpointgames.com/environments',
    launchpad: true,
  }),
  ptm: extendDefaultConfig({
    madId: 360,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-ptm.socialpointgames.com/environments',
    launchpad: false,
  }),
  tmc: extendDefaultConfig({
    madId: 361,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-tmc.socialpointgames.com/environments',
    launchpad: false,
  }),
  sr: extendDefaultConfig({
    madId: 376,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-sr.socialpointgames.com/environments',
    launchpad: false,
  }),
  mip: extendDefaultConfig({
    madId: 378,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-mip.socialpointgames.com/environments',
    launchpad: false,
  }),
  twr: extendDefaultConfig({
    madId: 380,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-twr.socialpointgames.com/environments',
    googleLinkEnabled: true,
    launchpad: false,
  }),
  grd: extendDefaultConfig({
    madId: 379,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-grd.socialpointgames.com/environments',
    launchpad: false,
  }),
  bh: extendDefaultConfig({
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-bh.socialpointgames.com/environments',
    launchpad: false,
    madId: 381,
  }),
  mb: extendDefaultConfig({
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-mb.socialpointgames.com/environments',
    madId: 382,
    launchpad: false,
  }),
  sol: extendDefaultConfig({
    madId: 383,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-sol.socialpointgames.com/environments',
    launchpad: false,
  }),
  lpt11: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://lpt11-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  glt7m: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://gctpg-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  plp: extendDefaultConfig({
    madId: 381,
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-plp.socialpointgames.com/environments',
    launchpad: false,
  }),
  rck7r: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://gctpg-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  tyc88: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://gctpg-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  grd8t: extendDefaultConfig({
    madId: 219,
    isGit: true,
    dynApiEndpoint: 'https://dynapi.dev.ssp.zynga.com/environments',
    launchpad: true,
    proxyEndpoint: 'https://gctpg-toolboxproxy.dev.ssp.zynga.com/forward',
  }),
  gfl: extendDefaultConfig({
    isGit: true,
    dynApiEndpoint:
      'https://dynapi-internal.dev-gfl.socialpointgames.com/environments',
    launchpad: false,
  }),
};
export type ProjectIdentifier = keyof typeof projectsLocalConfig;
